import { PlayCircle, Search, Clock } from "lucide-react";
import { Input } from "@/components/ui/input";

const recordings = [
  {
    id: 1,
    title: "Monetization Masterclass - Part 1",
    description: "Complete guide to monetizing your faceless channel with multiple income streams.",
    duration: "47:32",
    date: "Dec 1, 2024",
    tags: ["Monetization", "Strategy"],
  },
  {
    id: 2,
    title: "Nexis AI Deep Dive",
    description: "Advanced techniques for using Nexis AI to generate viral scripts.",
    duration: "38:15",
    date: "Nov 28, 2024",
    tags: ["Nexis AI", "Scripts"],
  },
  {
    id: 3,
    title: "Channel Audit Session #23",
    description: "Live review of 5 member channels with actionable feedback.",
    duration: "1:12:45",
    date: "Nov 25, 2024",
    tags: ["Channel Review", "Growth"],
  },
];

export default function Recordings() {
  return (
    <div className="p-6 md:p-8">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-red-500/20 flex items-center justify-center">
            <PlayCircle className="w-6 h-6 text-red-400" />
          </div>
          <div>
            <h1 className="font-display text-2xl font-bold">Call Recordings</h1>
            <p className="text-muted-foreground">Watch past coaching sessions</p>
          </div>
        </div>
        <div className="relative max-w-xs w-full">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder="Search recordings..." className="pl-10 bg-muted border-border" />
        </div>
      </div>

      {/* Recordings Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl">
        {recordings.map((recording) => (
          <div key={recording.id} className="glass-card overflow-hidden group cursor-pointer hover:border-primary/20 transition-colors">
            {/* Thumbnail */}
            <div className="aspect-video bg-muted relative">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background/80 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <PlayCircle className="w-8 h-8 text-primary" />
                </div>
              </div>
              <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-background/80 text-xs text-foreground">
                {recording.duration}
              </div>
            </div>
            
            {/* Content */}
            <div className="p-4">
              <h2 className="font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                {recording.title}
              </h2>
              <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                {recording.description}
              </p>
              <div className="flex items-center justify-between">
                <div className="flex gap-2">
                  {recording.tags.map((tag, i) => (
                    <span key={i} className="text-xs bg-muted px-2 py-1 rounded-full text-muted-foreground">
                      {tag}
                    </span>
                  ))}
                </div>
                <span className="text-xs text-muted-foreground">{recording.date}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {recordings.length === 0 && (
        <div className="text-center py-12">
          <PlayCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <h3 className="font-semibold text-foreground mb-2">No recordings yet</h3>
          <p className="text-muted-foreground">Past sessions will appear here.</p>
        </div>
      )}
    </div>
  );
}
